import * as React from 'react';
import './Nav.css';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faUser, faFileLines, faCircleQuestion, faNewspaper } from '@fortawesome/free-regular-svg-icons';
import { faChalkboardTeacher, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import UserAPI from '../_api/UserAPI';
import logo from '../../assets/modern_formats/dyslexico_transparent.webp';
import { Button } from '@mui/material';
import { useEffect } from 'react';


export default function Nav() {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const userAPI = new UserAPI();
  const { instance } = useMsal();

  useEffect(() => {
    //try logging in automatically if possible
    userAPI.handleLoginSilent(instance);
  }, []);

  const appList = (
    <>
      <Link data-testid="TextEditor" to="/textEditor" aria-label="Text Editor Page">
        <ListItem disablePadding>
          <ListItemButton sx={{ textAlign: 'center' }}>
            <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
              <FontAwesomeIcon data-testid="test_editor_icon" icon={faPenToSquare} style={{ marginRight: '8px' }} />
              TextEditor
            </ListItemText>
          </ListItemButton>
        </ListItem>
      </Link>
      <AuthenticatedTemplate>
        <Link data-testid="Documents" aria-label="Documents Page" to="/documents">
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
                <FontAwesomeIcon icon={faFileLines} style={{ marginRight: '8px' }} />
                Documents
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link data-testid="Analytics" aria-label="Analytics Page" to="/analytics">
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
                <FontAwesomeIcon icon={faChartLine} style={{ marginRight: '8px' }} />
                Analytics
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link data-testid="Classroom" aria-label="Classroom Page" to="/adminDash">
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
                <FontAwesomeIcon icon={faChalkboardTeacher} style={{ marginRight: '8px' }} />
                Classroom
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
               <Link aria-label="My Account Page" to="/account">
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
                <FontAwesomeIcon icon={faUser} style={{ marginRight: '8px' }} />
                My Account
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Link data-testid="Blog" to="/blog" aria-label="Blog Page">
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
                <FontAwesomeIcon icon={faNewspaper} style={{ marginRight: '8px' }} />
                Blog
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link data-testid="Help" to="/faq" aria-label="Help Page">
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
                <FontAwesomeIcon icon={faCircleQuestion} style={{ marginRight: '8px' }} />
                Help
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link data-testid="Sign in" aria-label="Sign In" to="/account" onClick={() => userAPI.handleLoginRedirect(instance)}>
          <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primaryTypographyProps={{ fontSize: '20px' }}>
                <FontAwesomeIcon icon={faUser} style={{ marginRight: '8px' }} />
                Sign in
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
      </UnauthenticatedTemplate>
    </>
  );

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box sx={{ my: 2 }}>
        <Link to="/home" aria-label="Home Page">
          <img style={{ height: '30px' }} alt="Dyslexico logo" src={logo} draggable={false}></img>
        </Link>
      </Box>
      <List>{appList}</List>
    </Box>
  );

  return (
    <>
      <AppBar component="nav" position="sticky" color="default" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar variant="dense">
          <Box sx={{ flexGrow: 1 }}>
            <Link to="/home" aria-label="Home Page">
              <Button disableRipple>
                <img style={{ height: '30px', padding: '0' }} alt="Dyslexico logo" src={logo} draggable={false}></img>
              </Button>
            </Link>
          </Box>
          <IconButton
            color="inherit"
            aria-label="open navigation links dropdown"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <List
              disablePadding
              sx={{ display: 'flex', flexDirection: 'row', fontSize: '20px', backgroundColor: 'unset' }}
              aria-label="navigation links"
            >
              {appList}
            </List>
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          anchor="top"
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </>
  );
}
